import React from 'react';

import { useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';

import Lozenge from '@atlaskit/lozenge';

import { useConversation } from '../../../../controllers/conversation/useConversation';

import messages from './messages';

export const VersionLozenge = (): React.JSX.Element | null => {
	di(useConversation);
	const { formatMessage } = useIntl();
	const { agentVersion } = useConversation();

	const versionType = agentVersion?.versionType;

	if (versionType === 'DRAFT') {
		return <Lozenge>{formatMessage(messages.draftVersion)}</Lozenge>;
	}

	// Don't render a LIVE lozenge: by default, sending a message to an agent
	// without an explicit version targets the LIVE version, so showing the
	// lozenge in this case is redundant and inconsistent with the "no lozenge
	// when nothing is selected" behaviour for the default case.
	if (versionType === 'LIVE') {
		return null;
	}

	// For other version types (e.g. superseded), show the version number
	if (agentVersion?.versionNumber != null) {
		return (
			<Lozenge>
				{formatMessage(messages.versionNumber, {
					versionNumber: agentVersion.versionNumber,
				})}
			</Lozenge>
		);
	}

	return null;
};
